'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dPath$0024$0024anon$0024126 from "./presto.types$-Path$$anon$126.js";
var $p;
/** @constructor */
function $c_Lpresto_types$Path$() {
  this.c93 = null;
  this.c94 = false;
  this.c91 = null;
  this.c92 = false;
  this.c95 = null;
  this.c96 = false;
}
export { $c_Lpresto_types$Path$ as $c_Lpresto_types$Path$ };
$p = $c_Lpresto_types$Path$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$Path$;
/** @constructor */
function $h_Lpresto_types$Path$() {
}
export { $h_Lpresto_types$Path$ as $h_Lpresto_types$Path$ };
$h_Lpresto_types$Path$.prototype = $p;
$p.cJb = (function() {
  if ((!this.c94)) {
    this.c93 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC;
    this.c94 = true;
  }
  return this.c93;
});
$p.iR = (function() {
  if ((!this.c92)) {
    this.c91 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a9;
    this.c92 = true;
  }
  return this.c91;
});
$p.cK7 = (function() {
  if ((!this.c96)) {
    this.c95 = new $j_presto$002etypes$0024$002dPath$0024$0024anon$0024126.$c_Lpresto_types$Path$$anon$126(this);
    this.c96 = true;
  }
  return this.c95;
});
var $d_Lpresto_types$Path$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$Path$, "presto.types$Path$", ({
  a0Q: 1,
  D: 1
}));
export { $d_Lpresto_types$Path$ as $d_Lpresto_types$Path$ };
var $n_Lpresto_types$Path$;
function $m_Lpresto_types$Path$() {
  if ((!$n_Lpresto_types$Path$)) {
    $n_Lpresto_types$Path$ = new $c_Lpresto_types$Path$();
  }
  return $n_Lpresto_types$Path$;
}
export { $m_Lpresto_types$Path$ as $m_Lpresto_types$Path$ };
//# sourceMappingURL=presto.types$-Path$.js.map
